import React, { useContext } from 'react';
import { SalesforceContext, CustomerTypes } from 'src/context/salesforce-context';
import './agent-information.scss';

export default function AgentInformation(props) {
  const { lead, customerType } = useContext(SalesforceContext);

  return (
    <div
      className={`AgentInformation input-area-container ${
        !props.isMobile ? 'container is-fluid container-padding' : ''
      }`}
    >
      {!props.isMobile && (
        <span>
          <div className="section-top" />
          <div className="input-area-container-heading padding-bottom-25 has-text-left personal-your-solution-heading">
            <p>Agent information</p>
          </div>
        </span>
      )}

      <div className="spacer-quarter" />

      <div className="text-block">
        <div className="edit-container-outer">
          <div>
            <p className="sub-heading tiny-sub-heading">
              {customerType === CustomerTypes.dealer ? 'Dealer ID' : 'Agent ID'}
            </p>
            <p className="text-body reskin_text">
              {customerType === CustomerTypes.dealer ? lead.dealerId : lead.agentId}
            </p>
          </div>
        </div>
      </div>
      <div className="spacer-quarter" />
    </div>
  );
}
